import { QUERY_KEY } from '@/constants/queryKey'
import { fetchPromoCategoryList, FeaturedCategoryRequest } from '@/api/fetchFeaturedCategoryList'
import { useQuery } from 'react-query'

const useFeaturedCategoryList = (params?: FeaturedCategoryRequest) => {
  const query = useQuery(QUERY_KEY.FETCH_PROMO_CATEGORY_LIST, () => fetchPromoCategoryList(params))

  return { ...query }
}

export default useFeaturedCategoryList
